import { render, staticRenderFns } from "./CallGroup.vue?vue&type=template&id=16b93c47&"
import script from "./CallGroup.vue?vue&type=script&lang=ts&"
export * from "./CallGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports